import { Action, createReducer, on } from '@ngrx/store';
import { CardActions } from './card.actions';
import { ICardState } from './card.state';
import { StateBuilder } from '../../../model/state.builder';

export const initialCardState: ICardState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const cardReducerFn = createReducer(
  initialCardState,
  on(CardActions.reset, (state: ICardState, action) => {
    return new StateBuilder<ICardState>(initialCardState).build();
  }),
  on(CardActions.load, (state: ICardState, action) => {
    return new StateBuilder<ICardState>(state).toLoading().build();
  }),
  on(CardActions.loadSuccess, (state: ICardState, action) => {
    return new StateBuilder<ICardState>(state, action).toLoaded().build();
  }),
  on(CardActions.submit, (state: ICardState, action) => {
    return new StateBuilder<ICardState>(state).toLoading().build();
  }),
  on(CardActions.submitSuccess, (state: ICardState, action) => {
    return new StateBuilder<ICardState>(state, action).toLoaded().build();
  })
);

export function cardReducer(state: ICardState | undefined, action: Action) {
  return cardReducerFn(state, action);
}
